import { Injectable } from '@angular/core';
import { LemsarApiClient } from '@lemsar/api/client';
import { Observable } from 'rxjs/Observable';
import { Province } from '@lemsar/institution/domains/model/institution';
import { ResponseTransformer } from '@lemsar/api/transformers/response';


@Injectable()
export class ProvinceService {
    public constructor(private api: LemsarApiClient) {}

    public fetchAllProvinces(): Observable<Province[]> {
        return this.api
            .get<any>('provinces')
            .pipe(ResponseTransformer.toData(), ResponseTransformer.toArrayClass(Province));
    }
}



// WEBPACK FOOTER //
// ./src/lemsar/common/domains/services/province.service.ts